module.exports = __webpack_public_path__ + "static/media/men-bulb-blue.f06b78e0.png";